<template>
  <v-card class="mt-8">
    <v-card-title>CTR</v-card-title>
    <v-card-subtitle>en fonction des jours de la semaine</v-card-subtitle>
    <v-card-text>
      <vue-apex-charts
        v-if="results"
        type="bar"
        :height="height"
        :options="chartOptions"
        :series="series"
      />
      <span v-else>{{ noDataText }}</span>
    </v-card-text>
  </v-card>
</template>

<script>
import BarChart from "@/components/common/charts/BarChart";
import { formatNumber, formatPercent } from "@/utils/formatting";
import axios from "@axios";
import VueApexCharts from "vue-apexcharts";
import { noDataText } from "@/utils/constants";

export default {
  name: "GlobalNbCreatedPostsChart",
  components: {
    VueApexCharts,
    BarChart,
  },
  props: {
    sites: {
      type: Array,
      default: () => [],
    },
    partnerViews: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      noDataText,
      height: "355",
      // loading: false,
      legend: true,
      outlined: false,
      series: [],
      labels: [],
      colors: ["#4285F4", "#EA4335"],
      formatter: (val) => formatNumber(val),
      chartOptions: {
        plotOptions: {
          bar: {
            dataLabels: {
              position: "top",
            },
          },
        },
        xAxis: { categories: [] },
        yaxis: [
          {
            min: 0,
            forceNiceScale: true,
            labels: {
              formatter: (val) => formatPercent(val),
            },
          },
        ],
        legend: {
          show: this.legend,
          position: "bottom",
          fontSize: "14px",
          fontFamily: '"Inter", sans-serif',
        },
        colors: ["#4285F4", "#EA4335"],
        dataLabels: {
          enabled: this.datalabels,
          textAnchor: "middle",
          style: {
            colors: ["#373D3FFF"],
            fontSize: "12px",
            fontFamily: "Helvetica, Arial, sans-serif",
            fontWeight: 400,
          },
          offsetY: -30,
          formatter: this.formatter,
          dropShadow: {
            enabled: true,
          },
        },
        tooltip: {
          shared: true,
          intersect: false,
          y: {
            formatter: (val) => formatPercent(val),
          },
        },
        fill: {
          opacity: 1,
        },
      },
    };
  },
  async created() {
    await this.getData();
  },
  methods: {
    updateOptions() {
      this.chartOptions = {
        ...this.chartOptions,
        xaxis: {
          categories: this.labels,
        },
        series: this.series,
        labels: this.labels,
      };
    },
    async getData() {
      this.series = null;
      this.labels = null;
      if (!this.results) return;
      if ("items" in this.results) {
        const data = this.results.items;
        this.series = [
          {
            name: "CTR",
            data: data.map((item) => item.ctr),
          },
        ];
        this.labels = data.map((item) => item.day);
      }
    },
  },
  computed: {
    results() {
      return this.$store.getters["gd/getData"]["weekdaysStats"];
    },
  },
  watch: {
    series() {
      this.updateOptions();
    },
    labels() {
      this.updateOptions();
    },
    results() {
      this.getData();
    },
  },
};
</script>
